

export interface GooglePayPaymentMethodData {
    environment?: GooglePayEnvironment
    apiVersion?: number
    apiVersionMinor?: number
    allowedPaymentMethods?: GooglePayAllowedPaymentMethod[]
}

export enum GooglePayEnvironment {
    TEST = 'TEST',
    PRODUCTION = 'PRODUCTION',
}

export interface GooglePayAllowedPaymentMethod {
    tokenizationSpecification?: GooglePayTokenization;
    parameters?: GooglePayAllowedPaymentMethodParams
    type?: string
}

export interface GooglePayTokenization {
    type?: GooglePayTokenizationType
    parameters?: {
        gatewayMerchantId?: string
        gateway?: string
    }
}

export enum GooglePayTokenizationType {
    PAYMENT_GATEWAY = 'PAYMENT_GATEWAY',
    DIRECT = 'DIRECT',
}

export interface GooglePayAllowedPaymentMethodParams {
    allowedAuthMethods?: GooglePayAuthMethods[]
    allowedCardNetworks?: GooglePayCardNetworks[]
}

export enum GooglePayCardNetworks {
    AMEX = 'AMEX',
    DISCOVER = 'DISCOVER',
    INTERAC = 'INTERAC',
    JCB = 'JCB',
    MASTERCARD = 'MASTERCARD',
    VISA = 'VISA',
}

export enum GooglePayAuthMethods {
    PAN_ONLY = 'PAN_ONLY',
    CRYPTOGRAM_3DS = 'CRYPTOGRAM_3DS'
}